export const header = {
  "x-ibm-client-id": process.env.REACT_APP_CLIENT_ID,
  "x-landmark-client-id": process.env.REACT_APP_LANDMARK_CLIENT_ID,
  "Access-Control-Allow-Origin": "*",
  // "Content-Type": "application/x-www-form-urlencoded",
};
